import React, { Component, Fragment, useEffect } from "react"
import Box from "@material-ui/core/Box"
import { Link } from "gatsby"
import { FiUser, FiMail, FiSettings, FiCheck, FiPower } from "react-icons/fi"
import { AccountLinks } from "../../constants"
import AccountMenuItem from "./accountItem"
import { useDispatch, useSelector } from "react-redux"
import * as actionCommon from "../../store/actions/commonActions"

const ProfileMediaMenu = () => {
  useEffect(() => {
    dispatch(actionCommon.userSettingPop(true))
  }, [])
  const dispatch = useDispatch()
  const userLinks = AccountLinks()
  return (
    <Fragment>
      <Box component="div" className="dropdown-menu dropdown-menu-right">
        {userLinks.map((linkProperties, i) => (
          <AccountMenuItem
            linkProps={linkProperties}
            key={i}
            clickFun={linkProperties.clickFunction}
          />
        ))}
      </Box>
    </Fragment>
  )
}

export default ProfileMediaMenu
